export class MessengerConstants {
  public static readonly viberUrl = 'viber://pa?chatURI=sdcompanybot&context=start';
  public static readonly telegramUrl = 'https://t.me/sd_company_bot';
}
